"use strict";

import {round, last, head} from 'lodash';
import {formatDate} from '../../formatters';

const d3 = require('d3');
const TS = require('@zerolight/zlthunder-time-utils');
const mix = require('../lib/mix');
const XAxis = require('../lib/axis').XAxis;
const BasicChart = require('./basic');

class DatesXAxis extends XAxis {
	constructor(scale, options) {
		super(scale, Object.assign({range: 'day'}, options));
	}

	get domain() {
		return this.scale.domain();
	}

	get range() {
		let domain = this.domain;
		return round((last(domain) - head(domain)) / TS.DAY);
	}

	tickFormatDay(tick) {
		let d = TS.validate(tick);
		let h = d.getUTCHours();
		if (h === 0) {
			return formatDate(d, 'D');
		} else if (h % 12 === 0) {
			return '12pm';
		} else if (h % 6 === 0) {
			return formatDate(d, 'h');
		}
	}

	tickFormatMonth(tick) {
		let d = TS.validate(tick);
		if (d.getDate() === 1) {
			return formatDate(d, 'MMM');
		}
	}

	initAxis() {
		let axis = this._axis = d3.axisBottom()
			.scale(this.scale).ticks(this.options.ticks)
			.tickSizeOuter(0);
		if (this.range > 45) {
			axis.tickFormat(this.tickFormatMonth);
		} else {
			axis.tickFormat(this.tickFormatDay);
		}
		return axis;
	}

	setTick(node, d, i) {
		d = TS.validate(d);
		let s = d3.select(node);
		s.attr('data-time', d.toISOString());
		let day = d.getUTCDay();
		let date = d.getUTCDate();
		if (day === 6 || day === 0) {
			s.classed('weekend', true);
		}
		if (date === 1 || i === 0) {
			s.append('tspan')
				.attr('dy', '1.2em')
				.attr('x', 0)
				.text(function (d) {
					return formatDate(d, 'MMM');
				});
		}
	}

	draw(node) {
		let s = super.draw(node);
		if (this.range <= 45) {
			let self = this;
			s.selectAll('text').each(function () {
				self.setTick(this, ...arguments);
			});
		}
		return s;
	}
}


function datesMixin(superclass) {
	return class extends superclass {
		calculateXDomain() {
			let domain = super.calculateXDomain();
			return TS.domain(domain[0], domain[1]);
		}

		initXAxis() {
			let options = this.options;
			return new DatesXAxis(
				this.xScale,
				{
					range: 'day', width: options.innerWidth,
					translate: [0, options.innerHeight]
				}
			);
		}
	};
}

const DatesChart = mix(BasicChart, datesMixin);

// Register mixin
mix.MIXINS.dates = datesMixin;

export {DatesChart, DatesXAxis, datesMixin};